export default __webpack_public_path__ + "static/media/help-ukrainians.4b766afd.png";